import { Form, Modal } from "antd";
import React from "react";
import { CreateDropDto } from "../../../api";
import { DropColumns } from "../form/columns";

interface DropFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateDrop: (values: CreateDropDto) => void;
}

export const DropForm: React.FC<DropFormProps> = ({ visible, setVisible, onCreateDrop }) => {
  const [form] = Form.useForm<CreateDropDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateDrop}>
        {DropColumns().map(({ title, key, rules, inputNode, hideOnForm }, index) => (
          <>
            {!hideOnForm && <Form.Item label={title} name={key} rules={rules} key={index}>
              {inputNode}
            </Form.Item>}
          </>
        ))}
      </Form>
    </Modal>
  );
};
